module.exports = __webpack_public_path__ + "static/media/F-1-2.6c0ba93d.webp";